module.exports = __webpack_public_path__ + "prod/1.42.2/img/power4.d4b68933.png";